export default "__VITE_ASSET__DnS01sn___";